import { createIconLoader, removeIconLoader } from "helpers/loader/loader";

const buttonLoader = (function () {
  // store needed elements
  const elements = {
    formSelector: 'form[data-on-submit="button-loader"]',
    buttonSelector: ".btn",
    invalidClassName: "is-invalid",
  };

  // init
  const init = function () {
    // get all forms with the data-on-submit="button-loader" attribute
    const forms = document.querySelectorAll(elements.formSelector);

    if (forms.length > 0) {
      forms.forEach(function (form) {
        // addEventListener to form submit
        form.addEventListener("submit", function () {
          handleSubmitButton(this);
        });
      });
    }
  };

  // handle submit button functionality
  const handleSubmitButton = (form) => {
    // use setTimeout to force new thread (otherwise the form.classList is not updated yet)
    setTimeout(function () {
      // check if form is not invalid because of form errors
      if (!form.classList.contains(elements.invalidClassName)) {
        // get all buttons inside form
        const buttons = form.querySelectorAll(elements.buttonSelector);

        if (buttons.length > 0) {
          buttons.forEach((button) => {
            // add data-is-submitting to button
            button.dataset.isSubmitting = "true";

            // insert loader into button
            createIconLoader(button);
          });
        }
      }
    }, 0);
  };

  const removeSubmitButtonLoader = (button) => {
    // reset form
    if (button) {
      button.dataset.isSubmitting = "false";
      removeIconLoader(button);
    }
  };

  return {
    init: init,
    removeSubmitButtonLoader,
  };
})();

export default buttonLoader;
